// Note: Default imports don't work here. Use named imports instead.
import Hero from '@/components/Hero';
import Accordion from '@/components/Accordion';
import GridBuilder from '@/components/GridBuilder';
import TextBlock from '@/components/TextBlock';
import EntryPromo from '@/components/EntryPromo';
import InfoList from '@/components/InfoList';
import EntryCarousel from '@/components/EntryCarousel';
import Testimonial from '@/components/Testimonial';
import GalleryBlock from '@/components/GalleryBlock';
import Callout from '@/components/Callout';
import TicketingWidget from '@/components/TicketingWidget';
import FormstackEmbed from '@/components/FormstackEmbed';
import InsetImage from '@/components/InsetImage';
import Lists from '@/components/Lists';
import FAQContentLayer from '@/components/FAQContentLayer';
import FullWidthImageBlock from '@/components/FullWidthImageBlock';
import PeopleGrid from '@/components/PeopleGrid';
import EventListing from '@/components/EventListing';
import PressListing from '@/components/PressListing';
import TicketTailorEmbed from '@/components/TicketTailorEmbed';
import Stack from '@/components/Stack';
import ImageGrid from '@/components/ImageGrid';

export const sectionDictionary = {
  hero: Hero,
  accordion: Accordion,
  gridBuilder: GridBuilder,
  textBlock: TextBlock,
  entryPromo: EntryPromo,
  infoList: InfoList,
  entryCarousel: EntryCarousel,
  testimonial: Testimonial,
  galleryBlock: GalleryBlock,
  callout: Callout,
  ticketing: TicketingWidget,
  formstackEmbed: FormstackEmbed,
  insetImage: InsetImage,
  lists: Lists,
  faqContentLayer: FAQContentLayer,
  fullWidthImageBlock: FullWidthImageBlock,
  peopleGrid: PeopleGrid,
  eventListing: EventListing,
  pressListing: PressListing,
  ticketTailorEmbed: TicketTailorEmbed,
  stack: Stack,
  imageGrid: ImageGrid,
};
